import { render, staticRenderFns } from "./FeaturesContent.vue?vue&type=template&id=38fde3be&scoped=true"
import script from "./FeaturesContent.vue?vue&type=script&lang=js"
export * from "./FeaturesContent.vue?vue&type=script&lang=js"
import style0 from "./FeaturesContent.vue?vue&type=style&index=0&id=38fde3be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fde3be",
  null
  
)

export default component.exports